import { ActionTypes } from '../constants/index';

export const fetchPrices = (payload: any) => ({
  type: ActionTypes.PRICE_MGMT_REQUEST,
  payload: {
    page: payload.page + 1,
    rowsPerPage: payload.rowsPerPage,
  },
});
